import React, { Component } from 'react';
import { Snackbar } from 'material-ui';
import R from 'ramda';

class NewSnackbarForContractDetailsContainer extends Component {
  shouldComponentUpdate(nextProps) {
    return !R.equals(
      this.props.shouldUpdate,
      nextProps.shouldUpdate
    );
  }

  render() {
    const { shouldUpdate, ...props } = this.props;
    return <Snackbar {...props} />;
  }
}

export default NewSnackbarForContractDetailsContainer;


// WEBPACK FOOTER //
// ./src/app/components/tc-ui/snack-bar-for-publish.jsx